var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ImmersivePage",
    {
      attrs: {
        appBarTitle: _vm.appBarTitle,
        route: _vm.backRoute,
        loading: _vm.loading,
      },
    },
    [
      !_vm.loading
        ? _c(
            "KPageContainer",
            { staticClass: "device-container" },
            [
              _c("FilteredChannelListContainer", {
                attrs: {
                  channels: _vm.allChannels,
                  selectedChannels: _vm.selectedChannels,
                  selectAllCheckbox: true,
                },
                on: {
                  "update:selectedChannels": function ($event) {
                    _vm.selectedChannels = $event
                  },
                  "update:selected-channels": function ($event) {
                    _vm.selectedChannels = $event
                  },
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c("h1", [
                            _vm._v(_vm._s(_vm.$tr("channelsOnDevice"))),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "default",
                      fn: function (ref) {
                        var showItem = ref.showItem
                        var handleChange = ref.handleChange
                        var itemIsSelected = ref.itemIsSelected
                        return _vm._l(_vm.allChannels, function (channel) {
                          return _c("ChannelPanel", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value: showItem(channel),
                                expression: "showItem(channel)",
                              },
                            ],
                            key: channel.id,
                            attrs: {
                              channel: channel,
                              selectedMessage:
                                _vm.channelSelectedMessage(channel),
                              checked: itemIsSelected(channel),
                            },
                            on: { checkboxchange: handleChange },
                          })
                        })
                      },
                    },
                  ],
                  null,
                  false,
                  3452274242
                ),
              }),
              _vm.showModal
                ? _c(
                    _vm.exportMode ? "SelectDriveModal" : "DeleteChannelModal",
                    _vm._b(
                      {
                        tag: "component",
                        on: {
                          cancel: function ($event) {
                            _vm.showModal = false
                          },
                          submit: _vm.handleClickModalSubmit,
                        },
                      },
                      "component",
                      _vm.modalProps,
                      false
                    )
                  )
                : _vm._e(),
              _c("SelectionBottomBar", {
                attrs: {
                  objectType: "channel",
                  disabled: _vm.selectedChannels.length === 0,
                  actionType: _vm.actionType,
                  selectedObjects: _vm.selectedChannels,
                  fileSize: _vm.fileSize,
                },
                on: {
                  "update:fileSize": function ($event) {
                    _vm.fileSize = $event
                  },
                  "update:file-size": function ($event) {
                    _vm.fileSize = $event
                  },
                  clickconfirm: _vm.handleClickConfirm,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }